import { DateTime } from "luxon";
import uuid from "uuid/v1";
import {
  priceTriggerType,
  OutcomePriceType,
} from "../../../api/constants/priceTriggerEnums";
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  IsStoreOpenAtTime,
  getCurrentDate,
} from "../../../api/helpers/datetimeHelper";
export default {
  computed: {
    ...mapGetters([
      "selectedCompany",
      "storeSelectionAtCheckoutMode",
      "deliveryAddress",
      "priceTriggerOutcomes",
      "cartValue",
      "cartItems",
      "totaltax",
      "getIsDelivery",
      "getShowDeliveryFee",
      "discount",
      "getTotalPrice",
      "deliveryFee",
      "mobileStyles",
      "desktopStyles",
      "canshowRedemption",
      "storeMenu",
      "getProductInCategoryInfo",
      "useStampCollection",
      "reedemptionPoints",
      "getSurchargeAmount",
      "getSurchargePercentage",
      "costlyCartItems",
      "currentStoreDoc",
      "addressOutOfService",
      "getSelectedTriggerCheckOutPage",
      "getTriggerCheckOutPage",
      "getloadedMenu",
      "getDeliveryAddressMessage",
      "getTotalPoints",
      "getProductOutcomeInfo",
      "getDeliveryIsLoading",
      "buttonStyles",
      "user",
      "storeSupportsLoyaltyPoints",
      "currencySign",
      "redemptionDiscount",
      "getloadedMenu",
      "showSharedCart",
      "getSharedCart",
      "getPeople",
      "getSharedCartProps",
      "totalGst",
    ]),
    taxLabel() {
      let locale = this.selectedCompany 
        ? this.selectedCompany.CurrencyLocaleName
        : null;
      locale = typeof locale === 'string' ? locale.toLowerCase() : locale;
      return locale === 'id-id' ? this.$t('message.tax') : this.$t('message.gst');
    },
    totalLabel() {
      let locale = this.selectedCompany 
        ? this.selectedCompany.CurrencyLocaleName
        : null;
      locale = typeof locale === 'string' ? locale.toLowerCase() : locale;
      return locale === 'id-id' ? this.$t('message.totalIncTax') : this.$t('message.totalIncGST');
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    getPoints() {
      if (this.storeSupportsLoyaltyPoints === true) return this.getTotalPoints;
      else return null;
    },
    wholeOrderDiscount() {
      var res = this.priceTriggerOutcomes.find(
        (pt) => pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
      );
      return res;
    },
    wholeOrderDiscountMessage() {
      var res = this.wholeOrderDiscount;
      if (res) {
        switch (res.OutcomePriceType) {
          case OutcomePriceType.OutcomePriceType_PercentageDiscount:
            if (!res.DiscountPercentageValue) return "";
            return (
              this.$t("message.thisOrderWillBeDiscounted") +
              " " +
              res.DiscountPercentageValue * 100 +
              "%"
            );
          case OutcomePriceType.OutcomePriceType_FlatDiscount:
            if (!res.DiscountFlatValue) return "";
            return (
              this.$t("message.thisOrderWillBeDiscounted") +
              " $" +
              res.DiscountFlatValue
            );
          default:
            return "";
        }
      }
      return "";
    },
    cartLength() {
      let sum = 0;
      this.cartItems
        .filter((p) => !p.disable)
        .forEach((element) => {
          sum += parseInt(element.quantity);
        });
      return sum;
    },
    totalPrice() {
      return this.getTotalPrice;
    },
    subtotalPrice() {
      return this.cartValue - (this.totalGst || 0);
    },
    showDelivery() {
      return this.getShowDeliveryFee && this.getIsDelivery;
    },
    exceedMinPurchase() {
      return this.subtotalPrice >= this.minPurchase;
    },
    refreshTime() {
      return DateTime.local()
        .set({ hour: 10, minute: 0, second: 0 })
        .toUTC();
    },
    now() {
      return DateTime.toUTC();
    },
    orderDisbaled() {
      if(this.selectedCompany.Delivery || this.selectedCompany.EatIn || this.selectedCompany.PickUp)
      {
        if (this.cartItems.filter((p) => !p.disable).length == 0) return true;
        if(this.minPurchase > 0)
        {
          if(!this.exceedMinPurchase) return true
        }
        return (
          !(
            this.exceedMinPurchase ||
            this.cartItems.filter((p) => !p.disable).length > 0
          ) ||
          this.costlyCartItems.length == 0 ||
          this.storeClosed === true ||
          !this.dpTimeIsSet ||
          !this.store.IsInOperation || this.proccessing || this.getDeliveryIsLoading
        );
      }else
      {
        return true;
      }
     
    },
    showDeliveryDistance() {
      return (
        this.$route.name.toLowerCase().indexOf("checkout") >= 0 &&
        this.addressOutOfService &&
        this.deliveryAddress.StreetAddress != ""
      );
    },
    hideSurcharge() {
      const config = this.currentStoreDoc
        && this.currentStoreDoc.ViewComponentConfigs;
      return config ? config.PayLaterOnly : false;
    },
  },
  methods: {
    ...mapMutations([
      "REMOVE_GIFTCART_ITEM",
      "REMOVE_CART_ITEM",
      "Add_ProductItem",
      "setShowDeliveryFee",
      "setShowOverlay",
    ]),
    ...mapActions([
      "insertErrorlog",
      "insertWarninglog",
      "redirectToErrorPage",
      "applyPriceTriggers",
      "fixRedemptionQuantity",
      "updateShoppingCartItems",
      "setItems",
    ]),
    navigateToCheckout() {
      if (
        this.showSharedCart &&
        this.getSharedCart &&
        this.getPeople.length > 0
      ) {
        const items = [];
        this.getPeople.forEach((user) => {
          const products = this.getSharedCart[user].products;
          products.map((product) => {
            items.push(product);
          });
        });
        this.setItems(items);
      }
      if (this.storeSelectionAtCheckoutMode) {
        var routename = this.isMobile() ? "checkout" : "mainpage";
        if (
          routename == 'checkout' &&
          this.currentStoreDoc.ViewComponentConfigs.LogIn &&
          this.currentStoreDoc.ViewComponentConfigs.LogInMandatory &&
          (
            !this.dbuser ||
            (
              this.currentStoreDoc.ViewComponentConfigs.SMSVerification &&
              !this.dbuser.isVerified
            )
          )
        ) {
          this.setShowOverlay(true);
        } else {
          this.$router.push({
            name: routename,
            query: this.isMobile()
              ? {}
              : {
                  selectMode: true,
                },
          });
        }
      } else {
        var routeName = this.IsSaveOrder ? "saveOrderMobile" : "checkout";
        if (
          routeName == 'checkout' &&
          this.currentStoreDoc.ViewComponentConfigs.LogIn &&
          this.currentStoreDoc.ViewComponentConfigs.LogInMandatory &&
          (
            !this.dbuser ||
            (
              this.currentStoreDoc.ViewComponentConfigs.SMSVerification &&
              !this.dbuser.isVerified
            )
          )
        ) {
          this.setShowOverlay(true);
        } else {
          this.$router.push({
            name: routeName,
            params: {
              storeid: this.$route.params.storeid,
              storename: this.$route.params.storename,
            },
          });
        }
      }
    },
    checkStoreClosed() {
      if (this.store.ChargeToRoom) {
        this.destroyOldCard();
        this.timerId = setInterval(this.destroyOldCard, 5000);
      }
      var now = getCurrentDate(this.store.TimezoneIanaFormat);
      if(!this.store.EnablePreoderForPickup && !this.store.EnablePreoderForDelivery) 
          now = now.plus({ minutes: this.store.OrderPreparationTime });

      this.storeClosed =
        (!IsStoreOpenAtTime(
          this.store.BlackoutDates,
          this.store.OperatingHours,
          this.store.IsInOperation,
          now
        ) &&
          !(
            this.store.EnablePreoderForDelivery ||
            this.store.EnablePreoderForPickup
          )) ||
        !this.store.IsInOperation;
      this.computeRules(this.orderType);
    },
    //desktop
    focusCart() {
      if (this.$refs.cartWrapper) this.$refs.cartWrapper.click();
    },
    applyCoupon(code) {
      this.$refs.couponComponent.applyCoupon(code);
    },
    SelecteDPTime(selecteDpTime) {
      if (!selecteDpTime) this.dpTimeIsSet = false;
      else this.dpTimeIsSet = true;
    },
    selectTriggerCheckOutPageEvent(value) {
      this.setSelectedTriggerCheckOutPage(value);
      this.$forceUpdate();
    },
    //mobile
    closeQrCodeScanner() {
      this.$refs.couponComponent.closeQrCodeScanner();
    },
    goOrder() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          torename: this.$route.params.storename,
        },
      });
    },
    continueOrder() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    clearAllOrders() {
      if (this.cartItems) {
        this.cartItems.forEach((cartitem) => {
          this.REMOVE_CART_ITEM({
            item: cartitem,
            sharedcart: this.showSharedCart,
            user: this.getSharedCartProps.user,
            table: this.getSharedCartProps.table,
            storeId: this.currentStoreDoc.ID
          });
          this.applyPriceTriggers();
        });
      }
    },
    destroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime) && this.cartItems) {
        this.cartItems.forEach((element) => {
          let createdTime = DateTime.fromFormat(element.created).toUTC();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_CART_ITEM({ item: element });
            this.applyPriceTriggers();
          }
        });
      }
    },
    giftDestroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime) && this.giftCartItems) {
        this.giftCartItems.forEach((element) => {
          let createdTime = DateTime.fromFormat(element.created).toUTC();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_GIFTCART_ITEM({ item: element });
          }
        });
      }
    },
    computeRules() {
      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
    },
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    },
    giftGoOrder() {
      this.$router.push({
        name: "giftstore",
        params: { storeid: this.store.ID, storename: this.store.Name },
      });
    },
    giftContinueOrder() {
      this.$router.push({
        name: "giftstore",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    giftComputeRules() {
      //delivery fee
      if (this.store && this.store.FreightFeeRules) {
        for (let i = 0; i < this.store.FreightFeeRules.length; i++) {
          const rule = this.store.FreightFeeRules[i];
          if (
            this.giftTotalPrice > rule.PriceRangeMinimum &&
            this.giftTotalPrice < rule.PriceRangeMaximum
          ) {
            this.deliveryFee = rule.FreightFeeAmount;
            break;
          }
        }
      }

      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
    },
    addReedemption() {
      var product = this.menuCopy.Products[
        this.canshowRedemption.ProductVariant
      ];
      if (product.ModifierGroups && product.ModifierGroups.length > 0) {
        this.selectedReedemption = {
          product: product,
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.canshowRedemption.ProductVariant.toString(),
        };
        this.showRedemption = true;
      } else {
        this.confirmReedemption(product);
      }
    },
    closeModal() {
      this.$refs.redemptionModal.hideModal();
      this.showRedemption = false;
    },
    selectRollIntoModiefiers(modifiers) {
      if (this.selectedReedemption) {
        this.confirmReedemption(this.selectedReedemption.product, modifiers);
        this.selectedReedemption = null;
        this.$refs.redemptionModal.hideModal();
        this.showRedemption = false;
        return;
      }
    },
    confirmReedemption(product, modifiers = []) {
      var productInfo = this.getProductInCategoryInfo(
        this.canshowRedemption.ProductVariant
      );
      var newPrice =
        productInfo.Price -
        productInfo.Price * (this.canshowRedemption.DiscountRate / 100);
      this.Add_ProductItem({
        item: {
          id: this.canshowRedemption.ProductVariant,
          uniqueId: uuid(),
          itemNote: "",
          code: product.ProductCode,
          name: product.Name,
          description: product.ShortDescription,
          photoUrl: product.PhotoUrl,
          tax: product.TaxRate,
          price: newPrice,
          reedemptionRule: this.canshowRedemption,
          RewardPoint: product.RewardPoint,
          categoryId:
            this.productInfo && this.productInfo.categoryId
              ? this.productInfo.categoryId
              : null,
          categoryName:
            this.productInfo && this.productInfo.categoryName
              ? this.productInfo.categoryName
              : null,
        },
        quantity: 1,
        PreparationTime: product.PreparationTime,
        ProductCategoryIDs: product.ProductCategoryIDs,
        ProductTagIDs: product.ProductTagIDs,
        modifiers: modifiers,
      });
      this.applyPriceTriggers();
    },
  },
};
